import  {eXcell,__extends} from './eXcell';
import {dhx4} from '../../global/dhx4OrDhx';

var eXcell_context = (function (_super) {
    __extends(eXcell_context, _super);
    function eXcell_context(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
            if (!this.grid._sub_context) {
                return;
            }
            this._sub = this.grid._sub_context[a._cellIndex];
            if (!this._sub) {
                return;
            }
            this._sindex = this._sub[1];
            this._sub = this._sub[0];
        }
    }
    eXcell_context.prototype.getValue = function () {
        return dhx4.isIE ? this.cell.innerText : this.cell.textContent;
    };
    eXcell_context.prototype.setValue = function (e) {
        this.cell._val = e;
        var c = this._sub.itemPull[this._sub.idPrefix + this.cell._val];
        e = c ? c.title : e;
        this.setCValue(e || "&nbsp;", e);
    };
    eXcell_context.prototype.edit = function () {
        var e = this.grid.getPosition(this.cell);
        this._sub.showContextMenu(e[0] + this.cell.offsetWidth, e[1]);
        var c = this.grid.editStop;
        this.grid.editStop = function () { };
        this.grid.editStop = c;
    };
    eXcell_context.prototype.detach = function () {
        if (this.grid._sub_id != null) {
            var c = this.cell._val;
            this.setValue(this.grid._sub_id);
            this.grid._sub_id = null;
            return this.cell._val != c;
        }
        this._sub.hideContextMenu();
    };
    return eXcell_context;
})(eXcell);
window.eXcell_context = eXcell_context;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_context.js